import React, { useState } from 'react';
import {
  DragHandle,
  TemplateSectionCard,
  TemplateSectionContent,
  TemplateSectionHeader,
} from '@components/TemplateSections';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import type { TemplateSectionItemProps } from './types';

export const TemplateSectionItem: React.FC<TemplateSectionItemProps> = ({
  section,
  onRemove,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: section.id,
    animateLayoutChanges: () => false, // Disable layout animations for better performance
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    // Only use transition when not dragging to prevent jump on drop
    transition: isDragging ? undefined : transition,
  };

  const hasContent = Boolean(section.content && section.content.trim().length > 0);

  return (
    <TemplateSectionCard
      variant="card"
      isDragging={isDragging}
      nodeRef={setNodeRef}
      style={style}
      dragHandleSlot={
        <DragHandle listeners={listeners} attributes={attributes} />
      }
    >
      <TemplateSectionHeader
        title={section.title}
        collapsible={hasContent}
        isExpanded={isExpanded}
        onToggleExpand={() => setIsExpanded(!isExpanded)}
        actions={
          <IconButton
            onClick={() => onRemove(section.id)}
            color="error"
            aria-label="Remove section"
            size="small"
          >
            <Delete fontSize="small" />
          </IconButton>
        }
      />
      {hasContent && (
        <TemplateSectionContent
          markdown={section.content}
          collapsed={!isExpanded}
        />
      )}
    </TemplateSectionCard>
  );
};
